import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatProgressBarModule } from '@angular/material/progress-bar'

import { UiFacade } from '~/core/features'

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, MatProgressBarModule],
})
export class ProgressBarComponent {
  uiFacade = inject(UiFacade)

  constructor() {}
}
